import React, { useState, useEffect } from 'react'
import Transparent from '../images/sprite/transparent.gif'
import axios from 'axios'
import { Link } from "react-router-dom";
import moment from 'moment'
import Cookies from 'universal-cookie';
require('moment-timezone');

const cookies = new Cookies();

export default function BasketballMatches(props) {

  const [match, setMatch] = useState([]);
  const [newrefresh, setnewrefresh] = useState(true);
  const [tv, settv] = useState([])
  const [bookmaker, setbookmaker] = useState([])
  const [cricketUpdate, setcricketUpdate] = useState(false);


  // vvvv


  const openAESexy = (gameI) => {
    if (!props.isLoggedIn) {
      props.checkShowLogin(true);
      return;
    }
    else {
      var utoken = cookies.get('token');
      var user = cookies.get('id');
      var mil = Date.now();

      if (!user || !utoken) {
        return;
      }
      setnewrefresh(true);
      axios.post('https://luckybdt.live/api/gapcasino/game/url', {
        user: user,
        token: utoken,
        platform: 'GPL_DESKTOP',
        lobby_url: window.location.href,
        game_id: gameI

      })
        .then(result => {

          setTimeout(() => { setnewrefresh(false); }, 4000);
          if (result.data.url) {
            // window.open(result.data.url);
            //var newTab=window.open('about:blank');
            window.location.href = result.data.url;

          }


        })
        .catch(e => {

        });

    }
  }
  // useEffect(() => {

  //   axios.get(
  //     `https://luckybdt.live/clientapi/Basketball`)

  //     .then(result => {
  //       result.data.map(item => {
  //         item.marketStartTime = moment.tz(item.marketStartTime, 'YYYY-MM-DD HH:mm:ss', 'Asia/Kolkata').local().format('YYYY-MM-DD HH:mm:ss');
  //         return item;
  //       })
  //       result.data.sort(function (a, b) {

  //         return moment(a.marketStartTime) - moment(b.marketStartTime);
  //       });
  //       setMatch(result.data);
  //       if (newrefresh) {
  //         setnewrefresh(false);
  //       }


  //     })


  //     .catch(error => console.log(error));

  //   axios.get(
  //     `https://luckybdt.live/clientapi/checktv`)

  //     .then(result => {

  //       settv(result.data);
  //     })
  //     .catch(error => console.log(error));

  //   axios.get(
  //     `https://luckybdt.live/clientapi/checkbookmaker`)

  //     .then(result => {

  //       setbookmaker(result.data);
  //     })
  //     .catch(error => console.log(error));
  // }, []);



  return (

    <React.Fragment>

      {newrefresh === true &&
        <div class="loading-overlay" id="loading">
          <div class="loading-wrap" style={{ display: " flex" }}>
            <div class="loading">
              <div></div>
              <div></div>
            </div>
            <p>Loading...</p>
          </div>
        </div>}



      {newrefresh === false && <div>

        {match.map(function (item, id) {

          var showtv = false;
          var isbookmaker = false;

          var showInplay = false

          var matchTime;
          var today = moment();
          var tommorow = moment().add(1, 'day');

          if (moment(item.marketStartTime).isSame(today, 'day')) {
            matchTime = moment(item.marketStartTime).format('LT');
          }
          else if (moment(item.marketStartTime).isSame(tommorow, 'day')) {
            matchTime = 'Tommorow' + ' ' + moment(item.marketStartTime).format('LT');;
          }
          else {
            matchTime = item.marketStartTime;
          }


          if (tv.includes(item.eventId)) {
            showtv = true;
          };
          if (bookmaker.includes(item.eventId)) {
            isbookmaker = true;

          };


          if (moment().diff(moment(item.marketStartTime), 'seconds') >= 0) {
            showInplay = true;
          }
          return (

            <li key={id} id="highlightEvent_29869541" className={`inplay${showInplay ? "-on" : "-off"}`}>
              <Link to={`/exchange/play/fullmarket/7522/${item.eventId}/${item.marketId}`} onClick={() => { props.changeState(true); }}>
                <dl>
                  <dt>
                    {showtv && moment(item.marketStartTime) &&
                      <span id="streamingIcon" className="game-live" style={{ display: "flex" }}>game-live</span>}
                    {isbookmaker &&
                      <span id="bookMakerIcon" className={`game-bookmaker ${showInplay ? "in-play" : "no-play"}`} style={{ display: "flex" }}><pre>in-play</pre>BookMaker</span>}
                    <span id="sportsBookIcon_2" className="game-sportsbook" style={{ display: "flex" }}>Premium Tennis</span>
                    {moment() >= moment(item.marketStartTime) &&
                      <span id="dateTimeInfo" className="time">In-play</span>}

                    {moment() < moment(item.marketStartTime) &&
                      <span id="dateTimeInfo" className="time">{matchTime}</span>}
                  </dt>
                  <dd id="eventName">{item.eventName}</dd>
                </dl>
              </Link>
              <a class="pin-off" ></a>

            </li>

          )
        })}
      </div>}
    </React.Fragment>
  )
}
